(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadFont = () => {
      if (document.querySelector('[data-mayhem-footer-font]')) return;
      const font = document.createElement('link');
      font.rel = 'stylesheet';
      font.href = 'https://fonts.googleapis.com/css2?family=Oxanium:wght@400;700&display=swap';
      font.dataset.mayhemFooterFont = '';
      document.head.appendChild(font);
    };

    const renderForm = (container) => {
      if (container.dataset.rendered === 'true' || !window.hbspt) return;
      container.dataset.rendered = 'true';
      const labelFrame = () => container.querySelectorAll('iframe').forEach(frame => { frame.title = container.dataset.frameTitle; });
      new MutationObserver(labelFrame).observe(container, { childList: true, subtree: true });
      labelFrame();
      let leadCounted = false;
      window.hbspt.forms.create({
        portalId: container.dataset.portalId,
        formId: container.dataset.formId,
        target: `#${container.id}`,
        onFormSubmitted: () => {
          if (container.dataset.formId !== '1e24773c-348c-47a5-b6d5-fe3151730ce6' || leadCounted) return;
          leadCounted = true;
          window.MayhemAnalytics?.track('generate_lead', { source: 'hubspot_dealer' });
        },
        onFormReady: (form) => {
          if (!container.classList.contains('mayhem-footer__hubspot')) return;
          const element = form?.nodeType === 1 ? form : form?.[0];
          element?.classList.add('mayhem-footer-newsletter');
          const document = element?.ownerDocument;
          if (!document || document.getElementById('mayhem-subscribe-button-color')) return;
          const style = document.createElement('style');
          style.id = 'mayhem-subscribe-button-color';
          style.textContent = '.mayhem-footer-newsletter label,.mayhem-footer-newsletter .hs-button{text-transform:uppercase!important}.mayhem-footer-newsletter .hs-button{background:#a62623!important;border-color:#a62623!important;color:#fff!important}.mayhem-footer-newsletter .hs-button:hover,.mayhem-footer-newsletter .hs-button:focus-visible{background:#861f1d!important;border-color:#861f1d!important;color:#fff!important}';
          document.head.appendChild(style);
        }
      });
    };

    const forms = document.querySelectorAll('[data-mayhem-hubspot]');
    if (!forms.length) return;
    loadFont();

    if (window.hbspt) {
      forms.forEach(renderForm);
      return;
    }

    let script = document.querySelector('[data-mayhem-hubspot-script]');
    if (!script) {
      script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      script.defer = true;
      script.dataset.mayhemHubspotScript = '';
      document.head.appendChild(script);
    }
    script.addEventListener('load', () => forms.forEach(renderForm), { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!window.__mayhemCollectionToolsLoaded) {
    window.__mayhemCollectionToolsLoaded = true;

    const cardSelector = '#ResultsList .product-grid__item:has([data-mayhem-wheel-card])';
    const splitValues = (value) => String(value || '').split('|').map((item) => item.trim()).filter(Boolean);
    const fitmentLabels = { Standard: 'Factory size (OE)', Upstep: 'Plus size', 'Minus Size': 'Minus size', Lifted: 'Lifted', Staggered: 'Staggered' };
    const displayFilterValue = (key, value) =>
      key === 'diameters' || key === 'widths' ? `${value}"` :
      key === 'offsets' ? `${value} mm` :
      key === 'fitment' ? fitmentLabels[value] || value : value;

    const getCards = () => [...document.querySelectorAll(cardSelector)];
    const scrollContainer = () => {
      const wrapper = document.querySelector('.page-wrapper');
      return wrapper && wrapper.scrollHeight > wrapper.clientHeight && /auto|scroll/.test(getComputedStyle(wrapper).overflowY)
        ? wrapper : document.scrollingElement;
    };
    const returnUrl = value => {
      const url = new URL(value, location.origin);
      // Vehicle initialization may normalize this flag without changing the collection.
      url.searchParams.delete('fitment');
      url.searchParams.sort();
      return url.href;
    };
    const returnState = history.state?.mayhemCollectionReturn;
    const returning = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    let restoreScroll = returning && returnState?.url && returnUrl(returnState.url) === returnUrl(location.href) ? returnState : null;
    window.addEventListener('pagehide', () => {
      history.replaceState({ ...history.state, mayhemCollectionReturn: {
        url: location.href, count: getCards().length, y: scrollContainer()?.scrollTop || 0
      } }, '', location.href);
    });
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      // BFCache preserves this closure, but fitment refresh can collapse the grid.
      const state = history.state?.mayhemCollectionReturn;
      if (state?.url && returnUrl(state.url) === returnUrl(location.href)) {
        restoreScroll = state;
        if (!Boolean(selectedVehicle())) requestAnimationFrame(restorePosition);
      }
    });
    for (const eventName of ['wheel', 'touchstart', 'pointerdown', 'keydown']) {
      window.addEventListener(eventName, () => { restoreScroll = null; }, { passive: true });
    }
    let restoringPages = true;
    const restorePosition = () => {
      if (restoringPages || !restoreScroll || document.documentElement.classList.contains('mayhem-fitment-only-loading')) return;
      const state = restoreScroll;
      requestAnimationFrame(() => {
        if (restoreScroll !== state) return;
        scrollContainer()?.scrollTo({ top: Math.max(0, Number(state.y) || 0), behavior: 'instant' });
        restoreScroll = null;
      });
    };

    const variantKeys = new Set(['diameters', 'widths', 'bolts', 'offsets', 'fitment']);
    const allCardVariants = card => {
      try { return JSON.parse(card.querySelector('[data-mayhem-card-variants]')?.textContent || '[]'); } catch { return []; }
    };
    const availableVariants = card => Boolean(selectedVehicle()) ? fittedVariants(card) : allCardVariants(card);
    const variantValues = (variant, key) => key === 'fitment' ? (variant.fitmentTypes || []) : key === 'bolts' ? String(variant.bolt || '').split('/').map(v => v.trim()).filter(v => /^\d{1,2}\s*[-x]\s*\d/.test(v)) : [variantValue(variant, key)];
    const fittedVariants = card => {
      try { return JSON.parse(card.querySelector('[data-mayhem-card-fitment]')?.dataset.matchedVariants || '[]'); }
      catch { return []; }
    };
    const variantValue = (variant, key) => {
      if (key === 'fitment') return variant.state || '';
      const size = String(variant.size || '').toLowerCase().split('x');
      if (key === 'diameters') return size[0]?.trim() || '';
      if (key === 'widths') return size[1]?.trim() || '';
      if (key === 'bolts') return String(variant.bolt || '').split(' /')[0].trim();
      if (key === 'offsets') {
        const offset = String(variant.offset ?? '').trim();
        return offset && Number.isFinite(Number(offset)) ? String(Number(offset)) : '';
      }
      return '';
    };

    const cardValues = (card, key, allVariants = false) => {
      const wheelCard = card.querySelector('[data-mayhem-wheel-card]');
      if (!wheelCard) return [];
      if (variantKeys.has(key)) {
        return [...new Set((allVariants ? allCardVariants(card) : availableVariants(card)).flatMap(variant => variantValues(variant, key)))].filter(Boolean);
      }
      const attribute = `mayhem${key.charAt(0).toUpperCase()}${key.slice(1)}`;
      return splitValues(wheelCard.dataset[attribute]);
    };

    const filterKeys = new Set(['finish', 'lug', 'diameters', 'widths', 'bolts', 'offsets', 'status', 'fitment']);
    const activeFilters = new Map();
    for (const key of filterKeys) {
      const values = new URL(location.href).searchParams.getAll('mf_' + key).filter(value => value && value.length <= 100).slice(0, 30);
      if (values.length) activeFilters.set(key, new Set(values));
    }
    const persistFilters = () => {
      const url = new URL(location.href);
      for (const key of filterKeys) {
        url.searchParams.delete('mf_' + key);
        for (const value of activeFilters.get(key) || []) url.searchParams.append('mf_' + key, value);
      }
      if (url.href !== location.href) history.replaceState(history.state, '', url.href);
    };


    const matchesFilters = (card, ignoredKey = null, requiredValue = null) => {
      for (const [key, values] of activeFilters) {
        if (key === ignoredKey || values.size === 0 || variantKeys.has(key)) continue;
        const available = cardValues(card, key);
        if (![...values].some((value) => available.includes(value))) return false;
      }
      if (ignoredKey && requiredValue && !variantKeys.has(ignoredKey) && !cardValues(card, ignoredKey).includes(requiredValue)) return false;
      const variants = availableVariants(card);
      return variants.some(variant => {
        for (const [key, values] of activeFilters) {
          if (!variantKeys.has(key) || key === ignoredKey || !values.size) continue;
          if (!variantValues(variant, key).some(value => values.has(value))) return false;
        }
        return !ignoredKey || !requiredValue || !variantKeys.has(ignoredKey) || variantValues(variant, ignoredKey).includes(requiredValue);
      });
    };

    const loadNextPage = async (button) => {
      const nextUrl = button?.dataset.nextUrl;
      if (!nextUrl || button.dataset.loading === 'true') return false;
      button.dataset.loading = 'true';
      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = button.dataset.loadingLabel;

      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(nextUrl, { headers: { Accept: 'text/html' }, signal: controller.signal });
        if (!response.ok) throw new Error(String(response.status));
        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const incomingGrid = documentFragment.querySelector('#ResultsList .product-grid');
        const currentGrid = document.querySelector('#ResultsList .product-grid');
        if (!incomingGrid || !currentGrid) throw new Error('Missing product grid');
        incomingGrid.querySelectorAll(':scope > .product-grid__item').forEach((item) => currentGrid.appendChild(item));
        const tools = getTools();
        if (tools) tools.dataset.filtersReady = 'false';
        const incomingButton = documentFragment.querySelector('[data-mayhem-load-more]');
        if (incomingButton?.dataset.nextUrl) {
          button.dataset.nextUrl = incomingButton.dataset.nextUrl;
          button.disabled = false;
          button.dataset.loading = 'false';
          button.textContent = originalText;
        } else {
          button.closest('.mayhem-load-more')?.remove();
        }
        return true;
      } catch {
        button.disabled = false;
        button.dataset.loading = 'false';
        button.textContent = originalText;
        if (Boolean(selectedVehicle())) {
          button.closest('.mayhem-load-more')?.remove();
          window.dispatchEvent(new Event('mayhem:collection-page-error'));
        }
        return false;
      } finally {
        clearTimeout(timeout);
      }
    };

    const loadAllPages = async () => {
      let button = document.querySelector('[data-mayhem-load-more]');
      while (button?.dataset.nextUrl) {
        const loaded = await loadNextPage(button);
        if (!loaded) break;
        button = document.querySelector('[data-mayhem-load-more]');
      }
    };

    const getTools = () => document.querySelector('[data-mayhem-collection-tools]');
    const vehicleTool = () => document.querySelector('[data-mayhem-collection-vehicle]');
    let photoRequest = 0;
    const selectedVehicle = () => {
      const native=window.TWGFitmentPreview?.selectedVehicle();
      if(native)return {id:'fg:'+JSON.stringify(native.query),native:true,details:{year:native.query.year,make:native.query.make,model:native.query.model,submodel:native.query.trimName||native.label.split(' · ').slice(3).join(' · ')}};
      if(window.TWGFitmentPreview?.status()?.mode==='twg_app_draft')return null;
      for (const store of [localStorage, sessionStorage]) {
        try {
          const id = store.getItem('mayhem:selected-vehicle-id');
          if (!/^\d+$/.test(id || '')) continue;
          const saved = JSON.parse(store.getItem('mayhem:selected-vehicle') || 'null');
          return { id, details: String(saved?.id) === id ? saved : null };
        } catch { /* Try the other storage location. */ }
      }
      return null;
    };
    const compactVehicleApplication = (value, body = '') => {
      const parts = String(value || '').split(' · ').map(part => part.trim()).filter(Boolean);
      const trim = parts[0] || '';
      const cab = String(body || parts.find(part => /\bcab\b/i.test(part)) || '')
        .replace(/\s+pickup.*$/i, '').trim();
      return [trim, cab].filter(Boolean).join(' · ');
    };
    const updateVehicleTool = () => {
      const tool = vehicleTool();
      if (!tool) return;
      const selected = selectedVehicle();
      tool.querySelector('[data-mayhem-collection-vehicle-select]').hidden = Boolean(selected);
      const card = tool.querySelector('[data-mayhem-collection-vehicle-selected]');
      card.hidden = !selected;
      if (!selected) { ++photoRequest; return; }
      const details = selected.details;
      tool.querySelector('[data-mayhem-collection-vehicle-name]').textContent =
        [details?.year, details?.make, details?.model].filter(Boolean).join(' ') || 'Selected vehicle';
      tool.querySelector('[data-mayhem-collection-vehicle-application]').textContent =
        details ? compactVehicleApplication(details.submodel) : 'Vehicle application selected';
      const photo = tool.querySelector('[data-mayhem-collection-vehicle-photo]');
      const fallback = tool.querySelector('[data-mayhem-collection-vehicle-fallback]');
      photo.hidden = true;
      fallback.removeAttribute('hidden');
      if(selected.native)return;
      const token = ++photoRequest;
      const cacheKey = 'mayhem:vehicle-photo:' + selected.id;
      let cached = details?.photoUrl;
      try { cached = localStorage.getItem(cacheKey) || sessionStorage.getItem(cacheKey) || cached; } catch { /* Photo caching is optional. */ }
      const showPhoto = src => {
        if (token !== photoRequest || selectedVehicle()?.id !== selected.id || !src) return;
        const reveal = () => {
          if (token === photoRequest && selectedVehicle()?.id === selected.id) {
            photo.hidden = false;
            fallback.setAttribute('hidden', '');
          }
        };
        photo.onload = reveal;
        photo.onerror = () => { photo.hidden = true; fallback.removeAttribute('hidden'); };
        if (photo.src !== src) photo.src = src;
        if (photo.complete && photo.naturalWidth > 0) reveal();
      };
      if (cached) showPhoto(cached);
      let vehicleRequest = window.mayhemGetVehiclePhoto?.(selected.id);
      if (!vehicleRequest) {
        const url = new URL('https://api.autosyncstudio.com/vehicles');
        url.searchParams.set('key', 'mayhem');
        url.searchParams.set('f-id', selected.id);
        url.searchParams.set('i-img001', 'true');
        vehicleRequest = fetch(url).then(response => response.ok ? response.json() : null);
      }
      vehicleRequest.then(data => {
        const row = data?.Vehicles?.find(item => String(item.Id) === selected.id);
        if (!row || token !== photoRequest) return;
        const path = row.Img001?.['350'] || row.Img001?.['240'];
        if (path && data.ImgUrlBase) {
          const src = new URL(path, data.ImgUrlBase).href;
          try { sessionStorage.setItem(cacheKey, src); localStorage.setItem(cacheKey, src); } catch { /* Photo caching is optional. */ }
          showPhoto(src);
        }
        tool.querySelector('[data-mayhem-collection-vehicle-name]').textContent =
          [row.Year, row.Make, row.Model].filter(Boolean).join(' ');
        tool.querySelector('[data-mayhem-collection-vehicle-application]').textContent =
          compactVehicleApplication(row.Submodel || 'Base', row.Body) || compactVehicleApplication(details?.submodel) || 'Vehicle application selected';
      }).catch(() => { /* Keep the vehicle text and fallback illustration. */ });
    };
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const vehicleSelect = event.target.closest('[data-mayhem-collection-vehicle-select], [data-mayhem-collection-vehicle-edit], [data-mayhem-mobile-vehicle-select]');
      if (vehicleSelect && getTools()) {
        event.stopImmediatePropagation();
        window.mayhemOpenVehiclePicker?.(vehicleSelect);
      }
    }, true);
    window.addEventListener('mayhem:vehicle-changed', () => {
      updateVehicleTool();
      if(window.TWGFitmentPreview?.status()?.mode==='twg_app_draft')return;
      if (!getCards().length) return;
      const destination = new URL(window.location.href);
      if (selectedVehicle()) destination.searchParams.set('fitment', 'matches');
      else {
        destination.searchParams.delete('fitment');
        destination.searchParams.delete('direct_fit');
      }
      window.location.assign(destination.href);
    });
    const syncVehicleRecovery = () => {
      const state=window.TWGFitmentPreview?.status()?.vehicleRestore;
      const needed=!window.TWGFitmentPreview?.selectedVehicle()&&['loading','needs_selection'].includes(state);
      let notice=document.querySelector('[data-twg-vehicle-recovery]');
      if(!needed){notice?.remove();return;}
      const results=document.querySelector('#ResultsList');if(!results)return;
      if(!notice){
        notice=document.createElement('div');notice.dataset.twgVehicleRecovery='';
        notice.setAttribute('role','status');notice.style.cssText='padding:24px;margin:16px 0;border:1px solid #ddd;border-radius:4px;';
        const message=document.createElement('p'),button=document.createElement('button');
        button.type='button';button.className='button';button.textContent='Select vehicle';
        button.addEventListener('click',()=>window.mayhemOpenVehiclePicker?.(button));
        notice.append(message,button);results.before(notice);
      }
      notice.querySelector('p').textContent=state==='loading'?'Restoring your saved vehicle for fitment…':'Please reselect your vehicle to check matching wheels. Your previous selection could not be confirmed.';
      notice.querySelector('button').hidden=state==='loading';
    };
    window.addEventListener('twg:vehicle-changed',()=>{updateVehicleTool();syncVehicleRecovery();updateFilterUi();});
    window.addEventListener('twg:vehicle-restore',syncVehicleRecovery);
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',syncVehicleRecovery,{once:true});else syncVehicleRecovery();
    window.addEventListener('storage', updateVehicleTool);
    window.addEventListener('pageshow', updateVehicleTool);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateVehicleTool, { once: true });
    else updateVehicleTool();

    let fitmentVehicleKey;
    const syncDirectFit = tools => {
      const vehicleKey = selectedVehicle()?.id || '';
      if (!vehicleKey || (fitmentVehicleKey !== undefined && fitmentVehicleKey !== vehicleKey)) activeFilters.delete('fitment');
      fitmentVehicleKey = vehicleKey;
      tools.dataset.directFitOnly = 'false';
      tools.querySelector('[data-mayhem-fitment-options]')?.toggleAttribute('hidden', !vehicleKey);
      const prompt = tools.querySelector('[data-mayhem-direct-fit-vehicle]');
      if (prompt) prompt.hidden = Boolean(vehicleKey);
      const destination = new URL(location.href);
      destination.searchParams.delete('direct_fit');
      if (destination.href !== location.href) history.replaceState(history.state, '', destination.href);
      tools.querySelectorAll('.mayhem-collection-tools__nav-link').forEach(link => {
        const target = new URL(link.href);
        target.searchParams.delete('direct_fit');
        target.searchParams.delete('mf_fitment');
        for (const type of activeFilters.get('fitment') || []) target.searchParams.append('mf_fitment', type);
        if (target.href !== link.href) link.href = target.href;
      });
      return false;
    };

    const updateFilterUi = () => {
      const tools = getTools();
      if (!tools) return;
      const directFitOnly = syncDirectFit(tools);
      persistFilters();
      const cards = getCards();
      let visibleCount = 0;
      cards.forEach((card) => {
        const passesFilters = matchesFilters(card);
        card.dataset.mayhemFilterExcluded = String(!passesFilters);
        const badge = card.querySelector('[data-mayhem-card-fitment]');
        let fitmentState = badge?.dataset.state;
        delete card.dataset.mayhemFilteredVariants;
        if (badge && Boolean(selectedVehicle()) && passesFilters) {
          const matching = fittedVariants(card).filter(variant => [...activeFilters].every(([key, values]) =>
            !variantKeys.has(key) || !values.size || variantValues(variant, key).some(value => values.has(value))));
          card.dataset.mayhemFilteredVariants = JSON.stringify(matching);
          const preferred = matching.find(variant => variant.state === 'fits') || matching[0];
          const link = card.querySelector('.mayhem-wheel-card__link');
          if (preferred && link) {
            const url = new URL(link.dataset.defaultHref || link.href);
            url.searchParams.set('variant', String(preferred.id).split('/').pop());
            link.href = url.href;
            badge.dataset.state = preferred.state;
            badge.dataset.sku = preferred.sku;
            const ui = window.MayhemFitmentUI;
            ui.paint(badge, preferred.state, {
              scope: 'card', sku: preferred.sku, configuration: ui.configuration(preferred),
              fitmentTypes: preferred.fitmentTypes || [], matches: matching,
              reasons: preferred.reasons || [],
              mixed: preferred.state === 'fits' && matching.some(variant => variant.state === 'caution')
            });
            fitmentState = preferred.state;
          }
        }
        if (passesFilters && !Boolean(selectedVehicle())) {
          const matching = allCardVariants(card).filter(variant => [...activeFilters].every(([key, values]) => !variantKeys.has(key) || !values.size || variantValues(variant, key).some(value => values.has(value))));
          card.dataset.mayhemFilteredVariants = JSON.stringify(matching);
          const link = card.querySelector('.mayhem-wheel-card__link');
          if (link && matching[0]?.id) {
            const url = new URL(link.dataset.defaultHref || link.href);
            url.searchParams.set('variant', String(matching[0].id).split('/').pop());
            link.href = url.href;
          }
        }
        const visible = passesFilters && (!Boolean(selectedVehicle()) ||
          fitmentState === 'fits' || fitmentState === 'caution');
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      tools.querySelectorAll('[data-mayhem-filter-input]').forEach((input) => {
        const count = cards.filter((card) =>
          (!Boolean(selectedVehicle()) ||
            ['fits', 'caution'].includes(card.querySelector('[data-mayhem-card-fitment]')?.dataset.state)) &&
          matchesFilters(card, input.dataset.filterKey, input.value)).length;
        const selected = input.dataset.filterKey === 'fitment' && !input.value
          ? !activeFilters.get('fitment')?.size : activeFilters.get(input.dataset.filterKey)?.has(input.value);
        if (input.dataset.filterKey === 'fitment') {
          const available = !input.value || cards.some(card => fittedVariants(card).some(variant => variantValues(variant, 'fitment').includes(input.value)));
          input.closest('label').hidden = !available && !selected;
        }
        input.checked = Boolean(selected);
        input.disabled = input.dataset.filterKey === 'fitment' ? !selectedVehicle() || (count === 0 && !selected) : count === 0 && !selected;
        input.closest('label')?.querySelector('[data-filter-count]')?.replaceChildren(document.createTextNode(String(count)));
      });

      const applied = tools.querySelector('[data-mayhem-applied-filters]');
      const filterButton = tools.querySelector('[data-mayhem-filter-toggle]');
      const countNode = tools.querySelector('[data-mayhem-filter-count]');
      const resultNode = tools.querySelector('[data-mayhem-results-count]');
      const chips = [];
      let activeCount = 0;
      for (const [key, values] of activeFilters) {
        for (const value of values) {
          activeCount += 1;
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'mayhem-collection-tools__applied-chip';
          chip.dataset.removeFilterKey = key;
          chip.dataset.removeFilterValue = value;
          chip.textContent = `${displayFilterValue(key, value)} ×`;
          chips.push(chip);
        }
      }
      const dialogApplied = tools.querySelector('[data-mayhem-dialog-applied]');
      dialogApplied?.replaceChildren(...chips.map(chip => chip.cloneNode(true)));
      if (dialogApplied) dialogApplied.hidden = chips.length === 0;
      tools.querySelector('[data-mayhem-dialog-results-count]')?.replaceChildren(document.createTextNode(`Show results (${visibleCount})`));
      const fitGroup = tools.querySelector('.mayhem-filter-direct-fit');
      const sortGroup = tools.querySelector('.mayhem-collection-tools__sort');
      if (fitGroup && sortGroup && fitGroup.parentElement === sortGroup.parentElement) {
        if (selectedVehicle()) sortGroup.before(fitGroup);
        else sortGroup.after(fitGroup);
      }
      applied?.replaceChildren(...chips);
      if (applied) applied.hidden = chips.length === 0;
      if (countNode) {
        countNode.textContent = String(activeCount);
        countNode.hidden = activeCount === 0;
      }
      if (filterButton) {
        const label = window.matchMedia('(max-width: 749px)').matches ? 'Filter & Sort' : filterButton.dataset.baseLabel;
        filterButton.setAttribute('aria-label', `${label} (${activeCount})`);
      }
      if (resultNode) resultNode.textContent = String(visibleCount);
      const resultLabel = tools.querySelector('[data-mayhem-results-label]');
      if (resultLabel) {
        const singular = resultLabel.dataset.labelOne || 'result';
        const plural = resultLabel.dataset.labelOther || 'results';
        resultLabel.textContent = selectedVehicle()
          ? (visibleCount === 1 ? 'matching wheel for your vehicle' : 'matching wheels for your vehicle')
          : (visibleCount === 1 ? singular : plural);
      }
      const empty = document.querySelector('[data-mayhem-direct-fit-empty]');
      if (empty) {
        const busy = tools.dataset.fitmentChecking === 'true' || document.documentElement.classList.contains('mayhem-fitment-only-loading');
        empty.hidden = visibleCount > 0 || busy || (!activeCount && !directFitOnly);
        if (!empty.hidden) {
          const description = empty.querySelector('p');
          if (description) description.textContent = directFitOnly
            ? 'No wheels match every selection with a Fits result. Remove a filter below, or include wheels that need review.'
            : 'No wheels match all your filters. Remove one below to try again.';
          const recovery = empty.querySelector('[data-mayhem-filter-recovery]');
          recovery?.replaceChildren(...chips.map(chip => {
            const button = chip.cloneNode(true);
            button.textContent = 'Remove ' + displayFilterValue(button.dataset.removeFilterKey, button.dataset.removeFilterValue);
            return button;
          }));
          const review = empty.querySelector('[data-mayhem-include-review]');
          if (review) review.hidden = !directFitOnly;
          const note = empty.querySelector('[data-mayhem-recovery-vehicle-note]');
          if (note) note.hidden = !selectedVehicle();
        }
      }
      // The selected variant can change a card's fitment rank after faceted filtering.
      window.dispatchEvent(new Event('mayhem:collection-filter-updated'));
    };

    const buildFilterGroups = () => {
      const tools = getTools();
      if (!tools || tools.dataset.filtersReady === 'true') return;
      const groupsNode = tools.querySelector('[data-mayhem-filter-groups]');
      const cards = getCards();
      const config = [
        ['diameters', tools.dataset.labelDiameter],
        ['bolts', tools.dataset.labelBolt],
        ['lug', tools.dataset.labelLug],
        ['finish', tools.dataset.labelFinish],
        ['widths', tools.dataset.labelWidth],
        ['offsets', tools.dataset.labelOffset],
        ['status', tools.dataset.labelStatus],
      ];

      const groups = config.map(([key, label]) => {
        const values = [...new Set(cards.flatMap((card) => cardValues(card, key, true)))].sort((left, right) => {
          // Natural text sorting treats decimal digits as separate integers (8.5 before 8.25).
          if (['diameters', 'widths', 'offsets', 'lug'].includes(key)) {
            const leftNumber = Number(left);
            const rightNumber = Number(right);
            if (String(left).trim() && String(right).trim() && Number.isFinite(leftNumber) && Number.isFinite(rightNumber)) {
              return leftNumber - rightNumber;
            }
          }
          return left.localeCompare(right, undefined, { numeric: true, sensitivity: 'base' });
        });
        if (values.length === 0) return null;
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'mayhem-filter-group';
        const legend = document.createElement('legend');
        legend.textContent = key === 'diameters' || key === 'widths' ? `${label} (in)` :
          key === 'offsets' ? `${label} (mm)` : label;
        fieldset.appendChild(legend);
        const options = document.createElement('div');
        options.className = 'mayhem-filter-group__options';
        values.forEach((value) => {
          const labelNode = document.createElement('label');
          labelNode.className = 'mayhem-filter-option';
          const input = document.createElement('input');
          input.type = 'checkbox';
          input.value = value;
          input.dataset.mayhemFilterInput = '';
          input.dataset.filterKey = key;
          const text = document.createElement('span');
          text.className = 'mayhem-filter-option__value';
          text.append(document.createTextNode(displayFilterValue(key, value)));
          const count = document.createElement('span');
          count.className = 'mayhem-filter-option__count';
          const countValue = document.createElement('span');
          countValue.dataset.filterCount = '';
          count.append(' (', countValue, ')');
          text.append(count);
          labelNode.append(input, text);
          options.appendChild(labelNode);
        });
        fieldset.appendChild(options);
        if (['widths', 'offsets'].includes(key)) {
          const disclosure = document.createElement('details');
          disclosure.className = 'mayhem-filter-disclosure';
          disclosure.open = !window.matchMedia('(max-width: 749px)').matches;
          const summary = document.createElement('summary');
          summary.textContent = legend.textContent;
          legend.className = 'visually-hidden';
          disclosure.append(summary, fieldset);
          return disclosure;
        }
        return fieldset;
      }).filter(Boolean);
      groupsNode?.replaceChildren(...groups);
      tools.dataset.filtersReady = 'true';
      updateFilterUi();
    };

    document.addEventListener('click', async (event) => {
      if (!(event.target instanceof Element)) return;
      const loadButton = event.target.closest('[data-mayhem-load-more]');
      if (loadButton) {
        await loadNextPage(loadButton);
        updateFilterUi();
        return;
      }

      const tools = getTools();
      if (!tools) return;
      const trigger = event.target.closest('[data-mayhem-filter-toggle], [data-mayhem-mobile-filter-toggle]');
      const toggle = trigger?.matches('[data-mayhem-mobile-filter-toggle]')
        ? tools.querySelector('[data-mayhem-filter-toggle]') : trigger;
      if (toggle) {
        window.MayhemMobileCollectionTools?.rememberTrigger(trigger);
        toggle.disabled = true;
        toggle.setAttribute('aria-busy', 'true');
        const labels = [...toggle.querySelectorAll('.mayhem-collection-tools__filter-label-desktop, .mayhem-collection-tools__filter-label-mobile')];
        const originalLabels = labels.map(label => label.textContent);
        const originalAriaLabel = toggle.getAttribute('aria-label');
        labels.forEach(label => { label.textContent = 'Loading filters…'; });
        toggle.setAttribute('aria-label', 'Loading filters…');
        try {
          await loadAllPages();
          buildFilterGroups();
          const dialog = tools.querySelector('[data-mayhem-filter-dialog]');
          dialog?.showModal();
          toggle.setAttribute('aria-expanded', 'true');
        } finally {
          labels.forEach((label, index) => { label.textContent = originalLabels[index]; });
          if (originalAriaLabel) toggle.setAttribute('aria-label', originalAriaLabel);
          else toggle.removeAttribute('aria-label');
          toggle.removeAttribute('aria-busy');
          toggle.disabled = false;
        }
        return;
      }

      if (event.target.closest('[data-mayhem-filter-close]')) {
        tools.querySelector('[data-mayhem-filter-dialog]')?.close();
        tools.querySelector('[data-mayhem-filter-toggle]')?.setAttribute('aria-expanded', 'false');
        return;
      }

      const vehiclePrompt = event.target.closest('[data-mayhem-direct-fit-vehicle]');
      if (vehiclePrompt) {
        // The collection and shared header handlers are both document-level.
        // Prevent the same click from reaching the header's outside-click
        // handler after opening the shared picker.
        event.stopImmediatePropagation();
        tools.querySelector('[data-mayhem-filter-dialog]')?.close();
        tools.querySelector('[data-mayhem-filter-toggle]')?.setAttribute('aria-expanded', 'false');
        window.mayhemOpenVehiclePicker?.(tools.querySelector('[data-mayhem-filter-toggle]'));
        return;
      }

      if (event.target.closest('[data-mayhem-include-review]')) {
        activeFilters.delete('fitment');
        updateFilterUi();
        return;
      }

      const remove = event.target.closest('[data-remove-filter-key]');
      if (remove) {
        activeFilters.get(remove.dataset.removeFilterKey)?.delete(remove.dataset.removeFilterValue);
        if (remove.closest('[data-mayhem-filter-recovery]')) window.MayhemJourney?.track('search_recovery', {surface:'collection',state:'filter_removed',has_vehicle:Boolean(selectedVehicle())});
        const input = tools.querySelector(
          `[data-filter-key="${CSS.escape(remove.dataset.removeFilterKey)}"][value="${CSS.escape(remove.dataset.removeFilterValue)}"]`
        );
        if (input) input.checked = false;
        const fromRecovery = Boolean(remove.closest('[data-mayhem-filter-recovery]'));
        updateFilterUi();
        if (fromRecovery) tools.querySelector('[data-mayhem-filter-toggle]')?.focus();
        return;
      }

      if (event.target.closest('[data-mayhem-clear-filters]')) {
        activeFilters.clear();
        tools.querySelectorAll('[data-mayhem-filter-input]').forEach((input) => { input.checked = false; });
        updateFilterUi();
      }
    });

    document.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-mayhem-filter-input]')) return;
      const key = event.target.dataset.filterKey;
      if (key === 'fitment') {
        activeFilters.delete('fitment');
        if (event.target.value) activeFilters.set('fitment', new Set([event.target.value]));
        updateFilterUi();
        return;
      }
      if (!activeFilters.has(key)) activeFilters.set(key, new Set());
      const values = activeFilters.get(key);
      if (event.target.checked) values.add(event.target.value);
      else values.delete(event.target.value);
      updateFilterUi();
    });
    window.addEventListener('mayhem:fitment-ready', () => { updateFilterUi(); restorePosition(); });
    const restoreFilters = async () => {
      if (!activeFilters.size) {
        // Recreate only the pages present before leaving this history entry.
        const count = Math.min(10000, Number(restoreScroll?.count) || 0);
        while (restoreScroll && getCards().length < count) {
          const button = document.querySelector('[data-mayhem-load-more]');
          if (!button || !(await loadNextPage(button))) break;
        }
        restoringPages = false;
        restorePosition();
        return;
      }
      updateFilterUi();
      const grid = document.querySelector('#ResultsList .product-grid');
      if (grid) new MutationObserver(() => {
        const tools = getTools();
        if (tools) tools.dataset.filtersReady = 'false';
        buildFilterGroups();
      }).observe(grid, { childList: true });
      await loadAllPages();
      const tools = getTools();
      if (tools) tools.dataset.filtersReady = 'false';
      buildFilterGroups();
      restoringPages = false;
      restorePosition();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreFilters, { once: true });
    else restoreFilters();


    document.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-mayhem-sort]')) return;
      const destination = new URL(window.location.href);
      destination.searchParams.set('sort_by', event.target.value);
      window.location.assign(destination.toString());
    });

    document.addEventListener('close', (event) => {
      if (!(event.target instanceof HTMLDialogElement) || !event.target.matches('[data-mayhem-filter-dialog]')) return;
      const toggle = getTools()?.querySelector('[data-mayhem-filter-toggle]');
      toggle?.setAttribute('aria-expanded', 'false');
      if (!document.querySelector('dialog[open]') && !window.MayhemMobileCollectionTools?.returnFocus()) toggle?.focus({ preventScroll: true });
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayhem-collection-accordion"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => document.querySelectorAll('[data-mh-accordion]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const panels = [...root.querySelectorAll('.mh-accordion__panel')];
    const activate = panel => {
      if (panel.classList.contains('is-active')) return;
      const mobile = matchMedia('(max-width:749px)').matches;
      const button = panel.querySelector('button');
      const before = button.getBoundingClientRect().top;
      panels.forEach(item => {
      const active = item === panel;
      item.classList.toggle('is-active', active);
      item.querySelector('button').setAttribute('aria-expanded', String(active));
      item.querySelector('.mh-accordion__detail').hidden = !active;
      });
      if (mobile) {
        const headerBottom = Math.max(0, document.querySelector('#header-component')?.getBoundingClientRect().bottom || 0);
        const desired = Math.max(headerBottom + 16, Math.min(before, innerHeight - 160));
        const delta = button.getBoundingClientRect().top - desired;
        window.scrollBy({top:delta,behavior:'instant'});
      }
    };
    panels.forEach((panel, index) => {
      panel.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && matchMedia('(hover:hover) and (min-width:750px)').matches && !root.contains(document.activeElement)) activate(panel);
      });
      panel.addEventListener('focusin', event => {
        if (event.target.matches(':focus-visible')) activate(panel);
      });
      const button = panel.querySelector('button');
      button.addEventListener('click', () => activate(panel));
      button.addEventListener('keydown', event => {
        let next;
        if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = (index + 1) % panels.length;
        if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = (index + panels.length - 1) % panels.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = panels.length - 1;
        if (next === undefined) return;
        event.preventDefault(); panels[next].querySelector('button').focus();
      });
    });
    if (panels.length) activate(panels[0]);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('.mh-accordion__panel');
    if (panel) panel.querySelector('button').click();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayhem-dealer-locator"]) return;
  try {
    
  (() => {
    const widget = document.getElementById('storelocatorwidget');
    const placeholder = 'Filters can be used to allow customers to narrow down their search by category. Separate multiple filters with a comma';
    const removePlaceholderCategory = () => {
      widget.querySelectorAll('.storelocator-checkbox-filter').forEach(category => {
        const label = category.querySelector('label');
        if (label?.textContent.trim() === placeholder) category.remove();
      });
      widget.querySelectorAll('option').forEach(option => {
        if (option.textContent.trim() === placeholder) option.remove();
      });
    };
    if (widget) {
      removePlaceholderCategory();
      new MutationObserver(removePlaceholderCategory).observe(widget, { childList: true, subtree: true });
    }
    if (document.getElementById('storelocatorscript')) return;

    const loadWidget = () => {
      const widgetScript = document.createElement('script');
      widgetScript.id = 'storelocatorscript';
      widgetScript.dataset.uid = '1ed332314cdcb94865ae09462fbcbfb1';
      widgetScript.src = 'https://cdn.storelocatorwidgets.com/widget/widget.js';
      widgetScript.async = true;
      document.head.appendChild(widgetScript);
    };

    if (window.google?.maps?.places) {
      loadWidget();
      return;
    }

    const mapsScript = document.createElement('script');
    mapsScript.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAJmEIwx-HguzWkb3Vo3EP-fWZVDssuZLs&libraries=places';
    mapsScript.async = true;
    mapsScript.addEventListener('load', loadWidget, { once: true });
    document.head.appendChild(mapsScript);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayhem-immersive-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => document.querySelectorAll('[data-mh-video-layer]').forEach(layer => {
    if (layer.dataset.videoReady) return;
    layer.dataset.videoReady = 'true';
    const hero = layer.closest('[data-mh-hero]');
    const button = hero.querySelector('[data-mh-video-toggle]');
    const mobile = matchMedia('(max-width:749px)');
    const motion = matchMedia('(prefers-reduced-motion:reduce)');
    let video = null;
    let pausedByUser = false;
    let inView = true;
    const label = () => { button.textContent = video && !video.paused ? button.dataset.pauseLabel : button.dataset.playLabel; };
    const play = () => { if (video) video.play().then(label).catch(label); };
    const update = () => {
      if (!video) return;
      if (document.hidden || !inView || pausedByUser || motion.matches) video.pause(); else play();
      label();
    };
    const load = () => {
      if (video) { video.pause(); video.remove(); video = null; }
      let template = layer.querySelector('[data-mh-video-desktop]');
      if (mobile.matches && layer.dataset.mobileMode === 'image') template = null;
      if (mobile.matches && layer.dataset.mobileMode === 'video') template = layer.querySelector('[data-mh-video-mobile]');
      button.hidden = !template;
      if (!template) return;
      video = template.content.querySelector('video').cloneNode(true);
      video.muted = true; video.defaultMuted = true;
      video.addEventListener('loadeddata', () => video?.classList.add('is-loaded'));
      video.addEventListener('error', () => { video?.classList.remove('is-loaded'); button.hidden = true; });
      video.addEventListener('play', label); video.addEventListener('pause', label);
      layer.append(video);
      update();
    };
    button.addEventListener('click', () => {
      if (!video) return;
      if (!video.paused) { pausedByUser = true; video.pause(); }
      else { pausedByUser = false; play(); }
      label();
    });
    mobile.addEventListener('change', load);
    motion.addEventListener('change', update);
    document.addEventListener('visibilitychange', update);
    if ('IntersectionObserver' in window) new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting; update();
    }, {threshold:.05}).observe(hero);
    load();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
